













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog, Toast } from 'vant';
import personalInformation from '@/components/common/personalInformation.vue';

@Component({ components: { personalInformation } })
export default class LocalForm extends Vue {
  phone: string = '';
  verificationCode: string = '';
  count: number = 0;
  timer: any = null;
  show: boolean = true;
  showEditPersonInfo: boolean = false;

  get SmsType() {
    return models.SmsType;
  }

  async getCode() {
    if (this.phone.length < 1) {
      Dialog.alert({
        title: '提示',
        message: '请输入手机号。',
      });
      return;
    }
    if (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.phone)) {
      const result = await api.AccountApp.localSendSms_POST({
        Phone: this.phone,
        Type: this.SmsType.登录验证,
      });

      if (result.success) {
        const TIME_COUNT = 30;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } else {
        Toast(result.message);
      }
    } else {
      Toast.fail('请输入正确的手机号码');
    }
  }

  async onSubmit(values: any) {
    this.showEditPersonInfo = true;
  }

  /**填写信息注册成功的回调 */
  registerSuccess(data) {
    this.showEditPersonInfo = false;
    this.$emit('localRegister', data);
  }
}
